import { Filter } from 'bad-words'


export const filterBadWords = (text = '') => {
   const exclude = ['willy']
   const filter = new Filter({
      exclude,
   })
   return filter.clean(text)
}
